import { render } from "./meetingChat.vue?vue&type=template&id=45cf46da"
import script from "./meetingChat.vue?vue&type=script&lang=js"
export * from "./meetingChat.vue?vue&type=script&lang=js"

import "./meetingChat.vue?vue&type=style&index=0&id=45cf46da&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__